<template>
    <div class="container">
        <img class="rotating-image" :src="itemData.url" alt="" @click="goToNotifications">
        <div class="dot glow-dot" v-if="messageCount"></div>
    </div>
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/user';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter()
const userStore = useUserStore()
const props = defineProps<{
    itemData: {
        url: string,
        redirect_url: string,
        display: boolean,
    }
}>()
const messageCount = computed(() => userStore.unreadCount)
const goToNotifications = () => {
    router.push('/sd-message')
}

</script>
<style scoped>
.container {
    position: fixed;
    bottom: 90px;
    left: 15px;
}

.container img {
    border-radius: 10px;
    width: 55px;
}

.dot {
    position: absolute;
    top: 0;
    right: 5px;
    background: red;
    border-radius: 30px;
    width: 10px;
    height: 10px;
    border: 1px solid rgba(255, 255, 255, 0.8);
}

.container img.rotating-image {
    cursor: pointer;
    animation: rotateImage 3s linear infinite;
    transform-origin: center center;
}

@keyframes rotateImage {

    0%,
    100% {
        transform: rotate(-10deg);
    }

    50% {
        transform: rotate(10deg);
    }
}

.glow-dot {
    box-shadow: 0 0 3px 3px rgba(255, 255, 255, 0.7);
    animation: pulseGlow 2s ease-out infinite;
}

@keyframes pulseGlow {
    0% {
        box-shadow: 0 0 3px 2px rgba(255, 255, 255, 0.6);
    }

    50% {
        box-shadow: 0 0 3px 3px rgba(255, 255, 255, 0.9);
    }

    100% {
        box-shadow: 0 0 3px 2px rgba(255, 255, 255, 0.6);
    }
}
</style>